import { compose } from 'react-recompose';
import _ from 'lodash';

import {
  _validateNetworkError,
  _validateTimeout,
  _validateNotOK,
  _validateWarnHelios,
  _validateWarn,
  _validateWarnCronos,
} from './validators';

import { _buildErrorObject, _extractAxiosResponse, _normalizeResponse } from './error-utils';

//Use to extract values from a positive response. We do not need to compose these as these should ONLY be called when the response was a success.
const extract = (response) => response.data.content;
const extract1 = (response) => response.data.content[0];

/**
 * Sometimes we have to deal with custom returns for a request responses. The shape of the data coming from the response can vary wildly and should be treated at a case by case basis. In this scenario createApiFailure action will not properly deal with the error message, so a custom solution will have to manually be implemented with the saga.
 *
 * With a complex error, the shape of your error should be:
 *
 * {
 *   error -> our error object
 *   errors -> will ONLY have the error messages without the data extracted
 * }
 *
 * thus , we need to drill deep into the error for failed data. This data can have any shape and is not guaranteed to be an object.
 *
 * We try to return the custom data from the error. We then fallback to the generic error if no custom error was detected.
 *
 * @param {Object} { Key: error } - a platform parsed response error object
 * @returns {
 * {Object} error --> the standard error object for CreateApiFailureAction to deal with
 * {Object} customError --> the extracted custom error data to be dealt with in the saga
 * }
 */
const extractFailedError = ({ error }) => {
  const customError = _.get(error, 'rawResponse.data.failed', undefined);

  if (customError) return { customError };
  return { error };
};

/**
 * Return a list of content items and a "meta" mapping of additional non-content fields. See pagination example below.
 *  ajaxService.get(url)
 *    .then(ApiUtils.validate)
 *    .then(ApiUtils.extractWithMeta(['nextUrl', 'prevUrl', 'count']))
 *
 * @param {array} metaFields  list of field names to return under the 'meta' mapping
 * @return {function}  formats the response in the following structure
 *  {
 *    content {array}   list of content items
 *    meta    {object}  named properties specified in the metaFields arg
 *  }
 */
const extractWithMeta =
  (metaFields = []) =>
    (response) => ({
      content: response.data.content,
      meta:    _.pick(response.data, metaFields),
    });

//We componse most exported data so that we make sure than, when used directly, they work even with an error response
const validate = compose(
  _validateWarn,
  _validateNotOK,
  _validateTimeout,
  _validateNetworkError,
  _normalizeResponse,
  _extractAxiosResponse
);
const validateHelios = compose(
  _validateWarn,
  _validateNotOK,
  _validateWarnHelios,
  _validateTimeout,
  _validateNetworkError,
  _normalizeResponse,
  _extractAxiosResponse
);
const validateCronos = compose(
  _validateWarnCronos,
  _validateNotOK,
  _validateTimeout,
  _validateNetworkError,
  _normalizeResponse,
  _extractAxiosResponse
);

const buildErrorObject = compose(_buildErrorObject, _extractAxiosResponse);

export default {
  buildErrorObject,

  extract,
  extract1,
  extractWithMeta,

  extractFailedError,

  validate,
  validateHelios,
  validateCronos,
};
